import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { FlexRow, TextWrapper, Wrapper, TextWrapperSpan } from "../../constants/common/StyledGlobalConstants";
import { useNavigate } from "react-router-dom";
import {
  CALL_US,
  CONFIRMATION_TO_EMAIL,
  CONTACT_TO_BOOK_APPOINTMENT,
  CONTACT_TO_DISCUSS_NEXT_STEP,
  INFORMATION_SAVED,
  TRACK_PROGRESS_IN_SUPPORT_CASES,
  CALL_US_GOVT,
} from "../../constants/technicianAppointmentConstants";
import "./TechnicianAppointmentsModal.css";
import { getPendoId } from "../../util/cfstPendoUtils";
import PropTypes from "prop-types";

const RequestSubmitted = ({
  isAssistanceRequired,
  isJobDurationExceeds10Hrs,
  caseId,
  caseNumber,
  isScheduleApiFailed,
  handleClickLink,
  windowSize,
}) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(`/support/cases/viewCaseDetails/${caseId}`);
    handleClickLink();
  };
  const titleRef = useRef(null);
  const { isSourcewellGovernment } = useSelector((state) => state.ACCOUNT);
  useEffect(() => {
    if (titleRef.current) {
      titleRef.current.focus();
    }
  }, []);

  function getRequestSubmittedTitle(isAssistanceRequired, isJobDurationExceeds10Hrs, isScheduleApiFailed) {
    if (isAssistanceRequired || isJobDurationExceeds10Hrs) {
      return "Request submitted";
    }
    if (isScheduleApiFailed) {
      return "Additional information required";
    }
    return "";
  }

  return (
    <Wrapper display="flex" marginBottom="6rem" gap="3rem">
      <Wrapper display="flex" flexDirection="column" gap="33px">
        {windowSize.width > 767 ? (
          <>
            <h1 className="sr-only" aria-live="assertive" role="alert" ref={titleRef}>
              {getRequestSubmittedTitle(isAssistanceRequired, isJobDurationExceeds10Hrs, isScheduleApiFailed)}
            </h1>
            <TextWrapper fontFamily="neue-haas-grotesk-display" fontSize="2.5rem" fontWeight="700" lineHeight="3rem" tabIndex="-1" aria-hidden="true">
              {isAssistanceRequired || isJobDurationExceeds10Hrs ? "Request submitted" : "Additional information required"}
            </TextWrapper>
          </>
        ) : (
          <TextWrapper
            fontFamily="neue-haas-grotesk-display"
            fontSize="2.5rem"
            fontWeight="700"
            lineHeight="3rem"
            tabIndex="0"
            role="alert"
            ref={titleRef}
          >
            {isAssistanceRequired || isJobDurationExceeds10Hrs ? "Request submitted" : "Additional information required"}
          </TextWrapper>
        )}
        <TextWrapper marginTop="2.063rem" fontFamily="neue-haas-grotesk-text" fontSize="0.875rem" lineHeight="1.25rem" fontWeight="400">
          {(isAssistanceRequired || isJobDurationExceeds10Hrs) && `${CONTACT_TO_DISCUSS_NEXT_STEP} ${CONFIRMATION_TO_EMAIL}`}
          {isScheduleApiFailed && `${INFORMATION_SAVED} ${CONTACT_TO_BOOK_APPOINTMENT} ${CONFIRMATION_TO_EMAIL}`}
        </TextWrapper>

        <TextWrapper marginTop="2.063rem" fontFamily="neue-haas-grotesk-text" fontSize="0.875rem" lineHeight="1.25rem" fontWeight="400">
          {(isAssistanceRequired || isJobDurationExceeds10Hrs) && `${TRACK_PROGRESS_IN_SUPPORT_CASES}`}
          {isScheduleApiFailed && `${TRACK_PROGRESS_IN_SUPPORT_CASES} ${isSourcewellGovernment ? CALL_US_GOVT : CALL_US}`}
        </TextWrapper>

        <FlexRow gap="5px">
          <TextWrapper
            id="case-number-label"
            marginTop="2.063rem"
            fontFamily="neue-haas-grotesk-text"
            fontSize="0.875rem"
            lineHeight="1.25rem"
            fontWeight="700"
            tabIndex="-1"
          >
            Case number:
          </TextWrapper>
          <TextWrapperSpan
            isLink
            aria-label={`Case number ${caseNumber}`}
            tabIndex="0"
            color="#006FC1"
            textDecorationLine="underline"
            fontFamily="neue-haas-grotesk-text"
            fontSize="0.875rem"
            id={getPendoId("case-number-link")}
            onClick={handleNavigate}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleNavigate()}
          >
            {caseNumber}
          </TextWrapperSpan>
        </FlexRow>
      </Wrapper>
    </Wrapper>
  );
};
RequestSubmitted.propTypes = {
  isAssistanceRequired: PropTypes.bool,
  isJobDurationExceeds10Hrs: PropTypes.bool,
  caseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  caseNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isScheduleApiFailed: PropTypes.bool,
  handleClickLink: PropTypes.func,
  windowSize: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number,
  }).isRequired,
};

export default RequestSubmitted;